(function () {
  // ========= CONFIG =========
  var PDP_ROOT_SELECTOR = '[data-pdp-root]';
  var FORM_SELECTOR = 'form.ProductForm';
  var SIZE_RADIO_SELECTOR = '.SizeSwatch__Radio';
  var PRODUCT_JSON_SELECTOR = 'script[data-product-json]';
  var PRESERVE_SELECTORS = ['[data-preserve]', '[data-wair-preserve]'];
  var CALLOUTS_CONTAINER_SELECTOR = '.Product__Callouts, .Feature__Callouts';
  var DESCRIPTION_PRESERVE_SELECTOR = '.ProductMeta__Description[data-preserve]';

  var lastSelectedOptions = [];

  // ========= UTILS =========
  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getPdpRoot() { return qs(document, PDP_ROOT_SELECTOR); }
  function getSectionIdFromRoot(root) { return root ? root.getAttribute('data-section-id') : null; }

  function getProductJSON(root) {
    var el = qs(root, PRODUCT_JSON_SELECTOR);
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return null; }
  }

  function cssEscape(str) { return String(str).replace(/["\\]/g, '\\$&'); }

  function getSelectedOptions(root) {
    var map = {};
    qsa(root, 'input[type="radio"][name^="option"]').forEach(function (r) {
      if (!r.checked) return;
      var pos = r.getAttribute('data-option-position');
      if (!pos) {
        var m = r.name.match(/option-?(\d+)/i);
        if (m) pos = String(parseInt(m[1], 10) + 1);
      }
      if (!pos) pos = '1';
      map[pos] = r.value;
    });
    return Object.keys(map)
      .sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); })
      .map(function (k) { return map[k]; });
  }

  function applyOptionsToDOM(root, optionsArr) {
    if (!root || !optionsArr || !optionsArr.length) return;
    for (var i = 0; i < optionsArr.length; i++) {
      var val = optionsArr[i];
      var sel = 'input[type="radio"][name^="option"][value="' + cssEscape(val) + '"][data-option-position="' + (i + 1) + '"]';
      var radio = qs(root, sel) || qs(root, 'input[type="radio"][name^="option"][value="' + cssEscape(val) + '"]');
      if (radio && !radio.checked) radio.checked = true;
    }
  }

  function findVariantIdByOptions(productData, optionsArr) {
    var variants = productData && productData.product && productData.product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < optionsArr.length; j++) {
        if ((v.options[j] || '') !== (optionsArr[j] || '')) { ok = false; break; }
      }
      if (ok) return String(v.id);
    }
    return null;
  }

  function updateUrlVariantParam(variantId) {
    if (!variantId) return;
    var u = new URL(window.location.href);
    u.searchParams.set('variant', variantId);
    var state = Object.assign({}, history.state || {}, { ajaxProduct: true, variantId: variantId });
    history.replaceState(state, '', u.pathname + u.search);
  }

  // ========= VARIANT ID SYNC =========
  function ensureHiddenVariantInputAndSync(root) {
    var form = qs(root, FORM_SELECTOR);
    if (!form) return;

    var data = getProductJSON(root);
    if (!data) return;

    var hidden = form.querySelector('input[type="hidden"][name="id"]');
    var select = form.querySelector('select[name="id"]');

    if (!hidden && !select) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'id';
      form.appendChild(hidden);
    }

    function setIdField(vid) {
      if (!vid) return;
      var idStr = String(vid);
      if (hidden) hidden.value = idStr;
      if (select) select.value = idStr;
      updateUrlVariantParam(idStr);
    }

    function run() {
      var opts = getSelectedOptions(root);
      var vid = findVariantIdByOptions(data, opts) || data.selected_variant_id;
      setIdField(vid);
    }

    run();

    qsa(root, SIZE_RADIO_SELECTOR).forEach(function (r) {
      r.addEventListener('change', run);
    });
  }

  // ========= FLICKITY REINIT =========
  function reinitFlickity(root) {
    try {
      var galleries = qsa(root, '.Product__Slideshow.Carousel');
      galleries.forEach(function (el) {
        if (el._flickity && el._flickity.destroy) { el._flickity.destroy(); }
        var cfgStr = el.getAttribute('data-flickity-config') || '{}';
        var cfg = {};
        try { cfg = JSON.parse(cfgStr); } catch (e) {}
        if (window.Flickity) { el._flickity = new window.Flickity(el, cfg); }
      });
    } catch (e) {}
  }

  // ========= ACCORDION (delegated; survives swaps) =========
  document.addEventListener('click', function(e){
    var tab = e.target.closest('.accordion-tab');
    if (!tab || !tab.closest(PDP_ROOT_SELECTOR)) return;

    var panel = tab.nextElementSibling;
    var accordionRoot = tab.parentNode;

    qsa(accordionRoot, '.accordion-tab.active').forEach(function (t) {
      if (t !== tab) {
        t.classList.remove('active');
        var p = t.nextElementSibling;
        if (p) p.style.maxHeight = null;
      }
    });

    tab.classList.toggle('active');

    if (panel) {
      if (tab.classList.contains('active')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = null;
      }

      qsa(panel, 'img').forEach(function(img){
        img.addEventListener('load', function(){
          if (tab.classList.contains('active')) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }, { once: true });
      });
    }
  }, true);

  // ========= IMAGE HYDRATION =========
  function hydrateInitialImages(root) {
    qsa(root, 'img').forEach(function (img) {
      if (!img.getAttribute('src') && img.dataset && img.dataset.src && img.dataset.src.indexOf('{width}') === -1) {
        img.setAttribute('src', img.dataset.src);
      }
      if (!img.getAttribute('srcset') && img.dataset && img.dataset.srcset && img.dataset.srcset.indexOf('{width}') === -1) {
        img.setAttribute('srcset', img.dataset.srcset);
      }
      if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  }

  // ========= AJAX ADD TO CART + REBUY =========
  function bindAjaxAddToCart(root) {
    if (!root) return;

    var form = qs(root, FORM_SELECTOR);
    if (!form) return;

    if (form._ajaxBound) return;
    form._ajaxBound = true;

    form.addEventListener('submit', function (e) {
      var submitter = e.submitter || document.activeElement;

      var isModalTrigger =
        submitter &&
        submitter.matches(
          '[data-action="open-modal"], .Fabric_Care_Btn, .final-sale'
        );

      if (isModalTrigger) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      var fd = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          try {
            if (window.Rebuy && Rebuy.SmartCart) {
              if (typeof Rebuy.SmartCart.show === 'function') {
                Rebuy.SmartCart.show();
              }
              if (typeof Rebuy.SmartCart.reload === 'function') {
                Rebuy.SmartCart.reload();
              }
            } else {
              window.location.href = '/cart';
            }
          } catch (err) {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    });
  }

  // ========= THEME HOOK =========
  // Fire section:unload BEFORE section:load so the Prestige theme's
  // SectionContainer properly tears down the old ProductSection instance.
  // Without this, the old instance's ResizeObserver keeps running against
  // detached DOM nodes — .closest('.Product__InfoWrapper') returns null on
  // a detached element, causing "Cannot read properties of null ('style')"
  // in an infinite loop that hangs the page.
  function teardownOldSection(sectionId) {
    if (!sectionId) return;
    try {
      document.dispatchEvent(
        new CustomEvent('shopify:section:unload', {
          bubbles: true,
          detail: { sectionId: sectionId }
        })
      );
    } catch (e) {}
  }

  function initThemeOnNewSection(root) {
    var sid = getSectionIdFromRoot(root);

    // Tear down old instance first so its ResizeObserver is disconnected
    teardownOldSection(sid);

    try {
      if (sid) {
        var sectionEl = root.closest('.shopify-section') || root;
        sectionEl.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: sid }
          })
        );
      }
    } catch (e) {}

    try {
      if (window.theme && typeof window.theme.initProduct === 'function') {
        window.theme.initProduct(root);
      }
    } catch (e) {}

    hydrateInitialImages(root);
    reinitFlickity(root);
    bindAjaxAddToCart(root);

    setTimeout(function () {
      if (window.initKlaviyoBIS) {
        window.initKlaviyoBIS();
      }
    }, 200);

    try {
      window.dispatchEvent(new Event('resize'));
    } catch (e) {}
  }

  // ========= FETCH HELPERS =========
  function buildSectionsURL(productURL, sectionIds) {
    var u = new URL(productURL, window.location.origin);
    if (Array.isArray(sectionIds) && sectionIds.length) u.searchParams.set('sections', sectionIds.join(','));
    return u.toString();
  }

  function fetchSections(productURL, sectionIds) {
    var url = buildSectionsURL(productURL, sectionIds);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.json(); });
  }

  // ========= PRESERVE ISLANDS =========
  function transplantPreservedIslands(incomingRoot, oldRoot) {
    PRESERVE_SELECTORS.forEach(function (sel) {
      var oldNode = qs(oldRoot, sel);
      var newNode = qs(incomingRoot, sel);
      if (oldNode && newNode) { newNode.replaceWith(oldNode); }
    });
  }

  // ========= CALLOUTS IMG PATCH =========
  function patchCalloutImages(targetContainer, sourceHTML) {
    if (!targetContainer || !sourceHTML) return;
    var tmp = document.createElement('div'); tmp.innerHTML = sourceHTML;
    var srcContainer = qs(tmp, CALLOUTS_CONTAINER_SELECTOR);
    if (!srcContainer) return;
    var srcImgs = qsa(srcContainer, '.Callout__Image');
    var dstImgs = qsa(targetContainer, '.Callout__Image');
    for (var i = 0; i < dstImgs.length && i < srcImgs.length; i++) {
      var s = srcImgs[i], d = dstImgs[i];
      if (s.getAttribute('src')) d.setAttribute('src', s.getAttribute('src'));
      if (s.getAttribute('srcset')) d.setAttribute('srcset', s.getAttribute('srcset'));
      if (s.getAttribute('data-src')) d.setAttribute('data-src', s.getAttribute('data-src'));
      if (s.getAttribute('data-srcset')) d.setAttribute('data-srcset', s.getAttribute('data-srcset'));
      d.classList.add('is-loaded');
    }
  }

  function patchAccordionContent(targetContainer, sourceHTML) {
    if (!targetContainer || !sourceHTML) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = sourceHTML;

    var newDesc = tmp.querySelector(DESCRIPTION_PRESERVE_SELECTOR) ||
                  tmp.querySelector('.ProductMeta__Description');
    if (!newDesc) return;

    var oldAcc = targetContainer.querySelector('.accordion-div');
    var newAcc = newDesc.querySelector('.accordion-div');
    if (!oldAcc || !newAcc) return;

    var newTabs = Array.prototype.slice.call(newAcc.querySelectorAll('.accordion-tab'));

    Array.prototype.slice.call(oldAcc.querySelectorAll('.accordion-tab')).forEach(function (tab) {
      var label = tab.textContent.trim();
      var panel = tab.nextElementSibling;
      if (!panel) return;

      var oldDesc = panel.querySelector('.panel_description');
      if (!oldDesc) return;

      var matchTab = newTabs.find(function (nt) {
        return nt.textContent.trim() === label;
      });
      if (!matchTab) return;

      var newPanel = matchTab.nextElementSibling;
      if (!newPanel) return;

      var newDescInner = newPanel.querySelector('.panel_description');
      if (!newDescInner) return;

      oldDesc.innerHTML = newDescInner.innerHTML;
    });
  }

  // ========= SWAP FLOW =========
  function swapInNewSectionHTML(html, oldSection) {
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var incomingRoot = qs(tmp, PDP_ROOT_SELECTOR);
    if (!incomingRoot) return null;
    transplantPreservedIslands(incomingRoot, oldSection);
    oldSection.replaceWith(incomingRoot);
    return incomingRoot;
  }

  function handleAjaxSwapTo(urlHref) {
    var currentRoot = getPdpRoot();
    if (!currentRoot) return;

    lastSelectedOptions = getSelectedOptions(currentRoot);

    var mainSid = getSectionIdFromRoot(currentRoot);
    if (!mainSid) { window.location.href = urlHref; return; }

    var calloutsEl = qs(document, CALLOUTS_CONTAINER_SELECTOR);
    var calloutsSid = calloutsEl ? (calloutsEl.closest('[data-section-id]') && calloutsEl.closest('[data-section-id]').getAttribute('data-section-id')) : null;

    currentRoot.setAttribute('aria-busy', 'true');
    currentRoot.classList.add('is-loading');

    var sids = [mainSid];
    if (calloutsSid) sids.push(calloutsSid);

    fetchSections(urlHref, sids)
      .then(function (json) {
        var newRoot = swapInNewSectionHTML(json[mainSid] || '', currentRoot);
        if (!newRoot) { window.location.href = urlHref; return; }

        history.replaceState({ ajaxProduct: true, sectionId: mainSid }, '', new URL(urlHref, window.location.origin).pathname);

        applyOptionsToDOM(newRoot, lastSelectedOptions);

        ensureHiddenVariantInputAndSync(newRoot);

        initThemeOnNewSection(newRoot);

        if (calloutsSid && json[calloutsSid]) {
          patchCalloutImages(calloutsEl, json[calloutsSid]);
        }

        var descEl = qs(newRoot, DESCRIPTION_PRESERVE_SELECTOR);
        if (descEl && json[mainSid]) {
          patchAccordionContent(descEl, json[mainSid]);
        }

        newRoot.classList.remove('is-loading');
        newRoot.setAttribute('aria-busy', 'false');
      })
      .catch(function () { window.location.href = urlHref; });
  }

  // ========= POPSTATE (back/forward) =========
  function rehydrateFromPopstate() {
    var currentRoot = getPdpRoot();
    if (!currentRoot) return;
    var mainSid = getSectionIdFromRoot(currentRoot);
    if (!mainSid) return;

    var calloutsEl = qs(document, CALLOUTS_CONTAINER_SELECTOR);
    var calloutsSid = calloutsEl ? (calloutsEl.closest('[data-section-id]') && calloutsEl.closest('[data-section-id]').getAttribute('data-section-id')) : null;

    currentRoot.setAttribute('aria-busy', 'true');
    currentRoot.classList.add('is-loading');

    var sids = [mainSid];
    if (calloutsSid) sids.push(calloutsSid);

    fetchSections(window.location.href, sids)
      .then(function (json) {
        var newRoot = swapInNewSectionHTML(json[mainSid] || '', currentRoot);
        if (!newRoot) return;

        var u = new URL(window.location.href);
        var forced = u.searchParams.get('variant');
        if (forced) {
          var data = getProductJSON(newRoot);
          var vs = data && data.product && data.product.variants || [];
          for (var i = 0; i < vs.length; i++) {
            var v = vs[i];
            if (String(v.id) === String(forced)) { applyOptionsToDOM(newRoot, v.options || []); break; }
          }
        }

        ensureHiddenVariantInputAndSync(newRoot);
        initThemeOnNewSection(newRoot);

        if (calloutsSid && json[calloutsSid]) {
          patchCalloutImages(calloutsEl, json[calloutsSid]);
        }

        var descEl = qs(newRoot, DESCRIPTION_PRESERVE_SELECTOR);
        if (descEl && json[mainSid]) {
          patchAccordionContent(descEl, json[mainSid]);
        }

        newRoot.classList.remove('is-loading');
        newRoot.setAttribute('aria-busy', 'false');
      })
      .catch(function () {
        currentRoot.classList.remove('is-loading');
        currentRoot.setAttribute('aria-busy', 'false');
      });
  }

  // ========= EVENT BINDINGS =========
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.VariantSwatchList a, .VariantSwatchItem a');
    if (!link) return;
    var root = getPdpRoot();
    if (!root || !link.closest(PDP_ROOT_SELECTOR)) return;

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return;

    e.preventDefault();
    handleAjaxSwapTo(href);
  }, true);

  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.ajaxProduct) return;
    rehydrateFromPopstate();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var root = getPdpRoot();
    if (!root) return;
    lastSelectedOptions = getSelectedOptions(root);
    ensureHiddenVariantInputAndSync(root);
    // Theme already initialized ProductSection on DOMContentLoaded via
    // sections.register('product', ProductSection). Only hydrate images
    // and bind ATC — skip the full theme reinit to avoid duplicates.
    hydrateInitialImages(root);
    bindAjaxAddToCart(root);
  });
})();
